import { useMemo } from "react";

type OrderBumpProps = {
  offerId: string;
  variantId: string;
  orderBumpsInCheckout: any[];
  title: React.ReactNode;
  description: React.ReactNode;
  handleOrderBumpToggle: (variantId: string, selected: boolean) => void;
  disabled?: boolean;
};

function OrderBump({
  offerId,
  variantId,
  title,
  description,
  orderBumpsInCheckout,
  handleOrderBumpToggle,
  disabled = false,
}: OrderBumpProps) {
  const orderBump = useMemo(
    () =>
      orderBumpsInCheckout.find(
        (orderBump) => orderBump.variantId === variantId,
      ),
    [orderBumpsInCheckout, variantId],
  );

  const inputId = `order-bump-${offerId}`;
  const inputName = `order-bump-${offerId}`;

  return (
    <label
      htmlFor={inputId}
      className={`relative block touch-manipulation select-none rounded-md sm:rounded-[5px] border sm:border-2 border-dashed border-[rgb(33,37,41)] bg-[rgb(252,248,227)] p-3 sm:p-3 md:p-4 ${
        disabled
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer"
      }`}
      style={{ margin: "8px 0px 0px" }}
    >
      <div
        className="ob-header mb-2.5 sm:mb-3 flex items-start sm:items-center"
        style={{
          color: "rgb(0, 153, 34)",
          fontFamily: "Montserrat",
          fontWeight: "bold",
          fontSize: "13px",
          textAlign: "left",
        }}
      >
        <img
          src="https://img.funnelish.com/4224/20304/1643364132-arrow-flash-small.gif"
          alt="Arrow"
          className="hidden sm:inline-block mr-0 sm:mr-2 h-0 sm:h-4 md:h-5 w-auto shrink-0"
        />
        <input
          id={inputId}
          type="checkbox"
          name={inputName}
          checked={Boolean(orderBump?.selected)}
          disabled={disabled}
          onChange={(e) => {
            if (disabled) return;
            handleOrderBumpToggle(variantId, e.target.checked);
          }}
          className="mr-2 sm:mr-2 h-5 w-5 sm:h-4 sm:w-4 shrink-0 mt-0.5 sm:mt-0 disabled:cursor-not-allowed enabled:cursor-pointer"
        />
        <span className="ob-headline text-[11px] sm:text-xs md:text-[13px] leading-snug sm:leading-normal flex-1">
          {title}
        </span>
      </div>
      <div className="ob-content text-xs sm:text-sm">{description}</div>
    </label>
  );
}

export default OrderBump;
